export const parseBackendUtc = (timestamp?: string) => {
  if (!timestamp) return new Date();
  const [base, frac] = timestamp.split('.');
  const ms = frac ? frac.slice(0, 3).padEnd(3, '0') : '000';
  return new Date(`${base}.${ms}Z`);
};

const pad = (num: number): string => num.toString().padStart(2, '0');

export const formatFullDate = (date: Date, withoutTime?: boolean): string => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const dateStr = `${monthNames[date.getMonth()]} ${pad(date.getDate())}, ${date.getFullYear()}`;
  const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
  if (withoutTime) return dateStr;
  return `${dateStr} at ${timeStr}`;
};
